import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import themeLoader from "./common/themeloader/themeloader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UserProfileContextProvider } from "./Contexts/UserProfile";
import { MunicipalityContext } from "./Contexts/MunicipalityKey";
import calculateMunicipalityKey from "./Hooks/Municipality";
import { appStore } from "./common/configureStore";

themeLoader();

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

const container = document.getElementById("root")!;
const root = createRoot(container);

const currentMunicipality = calculateMunicipalityKey();

root.render(

  <QueryClientProvider client={queryClient}>
    <MunicipalityContext.Provider value={currentMunicipality}>
      <Provider store={appStore} stabilityCheck="never">
        <UserProfileContextProvider>
          <App />
        </UserProfileContextProvider>
      </Provider>
    </MunicipalityContext.Provider>
  </QueryClientProvider>
);
serviceWorker.unregister();